/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetUserCouponOptionRespVo } from './GetUserCouponOptionRespVo';
import {
    GetUserCouponOptionRespVoFromJSON,
    GetUserCouponOptionRespVoFromJSONTyped,
    GetUserCouponOptionRespVoToJSON,
    GetUserCouponOptionRespVoToJSONTyped,
} from './GetUserCouponOptionRespVo';

/**
 * 
 * @export
 * @interface ResponseListGetUserCouponOptionRespVo
 */
export interface ResponseListGetUserCouponOptionRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListGetUserCouponOptionRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListGetUserCouponOptionRespVo
     */
    message?: string;
    /**
     * 
     * @type {Array<GetUserCouponOptionRespVo>}
     * @memberof ResponseListGetUserCouponOptionRespVo
     */
    data?: Array<GetUserCouponOptionRespVo>;
}

/**
 * Check if a given object implements the ResponseListGetUserCouponOptionRespVo interface.
 */
export function instanceOfResponseListGetUserCouponOptionRespVo(value: object): value is ResponseListGetUserCouponOptionRespVo {
    return true;
}

export function ResponseListGetUserCouponOptionRespVoFromJSON(json: any): ResponseListGetUserCouponOptionRespVo {
    return ResponseListGetUserCouponOptionRespVoFromJSONTyped(json, false);
}

export function ResponseListGetUserCouponOptionRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListGetUserCouponOptionRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(GetUserCouponOptionRespVoFromJSON)),
    };
}

export function ResponseListGetUserCouponOptionRespVoToJSON(json: any): ResponseListGetUserCouponOptionRespVo {
    return ResponseListGetUserCouponOptionRespVoToJSONTyped(json, false);
}

export function ResponseListGetUserCouponOptionRespVoToJSONTyped(value?: ResponseListGetUserCouponOptionRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(GetUserCouponOptionRespVoToJSON)),
    };
}

